/// <reference types="@types/googlemaps" />
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGoogleAddressResponse } from '@nimbus-library/features/shared/models/google-maps/i-google-maps.model';

declare let google: any;

@Injectable()
export class GoogleMapApiClient {
  private geocoder: google.maps.Geocoder;

  public getAddress(address: string, region: boolean): Observable<IGoogleAddressResponse> {
    return new Observable((observer) => {
      if (address) {
        this.geocoder = new google.maps.Geocoder();
        const options = {
          address,
        };
        if (region) {
          options['componentRestrictions'] = {
            country: address,
          };
        }

        this.geocoder.geocode(options, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              const newAddress = results[0].geometry.location;
              const viewportObj = results[0].geometry.viewport;
              observer.next({
                lat: newAddress.lat(),
                lng: newAddress.lng(),
                viewport: viewportObj,
              });
              observer.complete();
            } else {
              observer.error('No results found');
            }
          } else {
            observer.error(`Geocode failed due to:${status}`);
          }
        });
      } else {
        observer.error('Input Address is empty for google map searching.');
      }
    });
  }
}
